import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { showModal, hideModal, setTokens } from 'appSrc/redux/actions';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import EditUserModal from '../../Modals/User/EditUserModal';
import { InternalLink, ExternalLink, PrimaryButton, UserAvatar, Icon } from 'appSrc/components/UI';
import InfiniteProductsTable from './ProductsTable';
import ArticlesTable from './ArticlesTable';
import UpdatePasswordModal from '../UpdatePassword';
import { tdcDomainMatch } from 'appSrc/utils/random';
import style from './styles/style.module.css';
import SortableReviewsTable from './ReviewsTable';

class IndividualUserPage extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            fetching: true,
            user: {},
            fetchingLists: true,
            products: [],
            fetchingProducts: true,
            articles: [],
            fetchingArticles: true,
            showUpdatePass: false,
            fetchingReviews: false,
            reviews: [],
        };
        this.productQueryObject = {
            page: 1,
            limit: 1000,
            sort: 'title,desireid',
        };
    }
    componentDidMount() {
        this.loadUser( this.props.match.params.uid );
        this.loadProducts( this.props.match.params.uid );
        this.loadArticles( this.props.match.params.uid );
        this.loadReviews( this.props.match.params.uid );
    }
    loadUser = ( userid ) => {
        this.props.getUser( userid )
        .then( ( user ) => {
            this.setState( {
                fetching: false,
                user: user,
            } );
        } );
    }
    loadArticles = ( userid ) => {
        dAPI.get( `/admin/users/${ userid }/curated-articles?limit=9999` )
        .then( ( articles ) => {
            this.setState( {
                fetchingArticles: false,
                articles: articles,
            } );
        } );
    }
    loadProducts = ( userid ) => {
        return this.props.getProducts( userid, this.productQueryObject )
        .then( ( products ) => {
            this.productQueryObject.page++;
            this.setState( ( altState ) => {
                altState.fetchingProducts = false;
                altState.products = altState.products.concat( products );
                return altState;
            } );
            return products;
        } );
    }
    loadReviews = ( userid ) => {
        dAPI.get( `/users/${ userid }/reviews?limit=9999` )
        .then( ( reviews ) => {
            this.setState( {
                fetchingReviews: false,
                reviews: reviews,
            } );
        } );
    } 
    openEditModal = () => {
        this.props.showModal( 'editUserModal' );
    }
    onEditSubmit = ( updates ) => {
        var calls = [];
        if( updates.affil.length > 0 ) {
            for( var i = 0; i < updates.affil.length; i++ ) {
                calls.push( this.props.updateUserAffiliateCode( updates.affil[i].userid, updates.affil[i] ) );
            }
        }
        return Promise.all( calls )
        .then( () => {
            return this.props.updateUser( updates.user.userid, updates.user );
        } )
        .then( ( updatedUser ) => {
            this.setState( { user: updatedUser } );
            return updatedUser;
        } );
    }
    onEditClose = () => {
        this.props.hideModal( 'editUserModal' );
    }
    reviewUpdated = ( index, review ) => {
        this.setState( ( altState ) => {
            if( review !== null ) {
                altState.reviews[ index ] = review;
            } else {
                altState.reviews.splice( index, 1 );
            }
            altState.reviews = altState.reviews.slice( 0 );
            return altState;
        } );
    }
    articleUpdated = ( index, article ) => {
        this.setState( ( altState ) => {
            if( article !== null ) {
                altState.articles[ index ] = article;
            } else {
                altState.articles.splice( index, 1 );
            }
            altState.articles = altState.articles.slice( 0 );
            return altState;
        } );
    }
    productUpdated = ( index, product ) => {
        this.setState( ( altState ) => {
            altState.products[ index ] = product;
            altState.products = altState.products.slice( 0 );
            return altState;
        } );
    }
    onProductListSort = ( sortValue ) => {
        if( this.productQueryObject.sort == sortValue ) {
            sortValue = `-${ sortValue }`;
        }
        this.productQueryObject.sort = sortValue;
        this.productQueryObject.page = 1;
        this.setState( ( altState ) => {
            altState.products = [];
            altState.fetchingProducts = true;
            return altState;
        } );
        this.loadProducts( this.props.match.params.uid );
    }
    loginAsUser = () => {
        this.props.getUsersToken( this.props.match.params.uid )
        .then( ( data ) => {
            this.props.setTokens( data );
            window.location.href = window.location.origin + '/app/dashboard';
        } );
    }


    render() {
        const { 
            fetching, user, 
            reviews, fetchingReviews, 
            products, fetchingProducts,
            articles, fetchingArticles } = this.state;
        const urlQuery = Object.decodeURLQuery( this.props.location.search );
        const activeTab = urlQuery.tab || 'articles';

        if( fetching ) {
            return (
                <section className={ style.individual }>
                    <LoadingReplace />
                </section>
            );
        }

        var affiliateCodes = {};
        for( var i = 0; i < user.affiliates.length; i++ ) {

            let aff = user.affiliates[ i ];
            let _aff;
            if(user.affiliates[ i ].UserAffiliate) {
                _aff = user.affiliates[i].UserAffiliate;
            } else {
                _aff = user.affiliates[i];
            }

            switch( aff.affiliateType ) {
                case 'Amazon':
                    affiliateCodes.amazon = _aff.subAffiliateCode;
                    break;
                case 'CJ':
                    affiliateCodes.cj = _aff.subAffiliateCode;
                    break;
                case 'Rakuten':
                    affiliateCodes.rakuten = _aff.subAffiliateCode;
                    break;
                case 'Target':
                    affiliateCodes.target = _aff.subAffiliateCode;
                    break;
            }
        }

        return (
            <section className={ style.individual }>
                <div className={ style.head }>
                    <div className={ style.controls }>
                        <div className={ style.backLink } onClick={ this.props.history.goBack }>Back</div>
                        <div>
                            <PrimaryButton label='Edit Profile' onClick={ this.openEditModal } />
                            <PrimaryButton label='Change Password' onClick={ () => ( this.setState( { showUpdatePass: true } ) ) }
                            style={ { marginLeft: '15px' } } />
                            <PrimaryButton label='Login as User' onClick={ this.loginAsUser }
                            style={ { marginLeft: '15px' } } />
                            <ExternalLink target='_blank' to={ `${ tdcDomainMatch() }/pros/${ user.slug }` }
                            style={ { marginLeft: '15px' } }>
                                <PrimaryButton reverse label='Public Profile' />
                            </ExternalLink>
                        </div>
                    </div>
                    <div className={ style.individualDetails }>
                        <div>
                            <UserAvatar src={ user.avatar } size={ 120 } />
                        </div>
                        <div>
                            <div className={ style.title }>
                                <h2 style={ { marginRight: '15px' } }>{ user.displayName }</h2>
                                <h3>{ user.usertype }</h3>
                            </div>
                            <div className={ style.description }>
                                <p>{ user.description }</p>
                            </div>
                        </div>
                        <div className={ style.links }>
                            <div>
                                <Icon source='fontAwesome' icon='fab/faYoutube' style={ { color: 'inheirit' } } faSize='2x' />
                                { user.intro_video &&
                                    <ExternalLink to={ `https://www.youtube.com/watch?v=${ user.intro_video }` }>{ `youtube.com/watch?v=${ user.intro_video }` }</ExternalLink>
                                }
                            </div>
                            <div>
                                <Icon source='fontAwesome' icon='fas/faEnvelope' style={ { color: 'inheirit' } } faSize='2x' />
                                <ExternalLink to={ `mailto:${ user.emailAddress }` }>{ user.emailAddress }</ExternalLink>
                            </div>
                            <div>
                                <Icon source='fontAwesome' icon='fas/faLink' faSize='2x' />
                                { user.website &&
                                    <ExternalLink to={ user.website }>{ user.website }</ExternalLink>
                                }
                            </div>
                        </div>
                        <div className={ style.affiliateCodes }>
                            <h4>Subaffiliate IDs</h4>
                            <div className={ style.codesWrapper }>
                                <div className={ style.codeLine }>
                                    <div className={ style.codeType }>Amazon</div>
                                    <div className={ style.codeValue }>{ affiliateCodes.amazon }</div>
                                </div>
                                <div className={ style.codeLine }>
                                    <div className={ style.codeType }>Rakuten</div>
                                    <div className={ style.codeValue }>{ affiliateCodes.rakuten }</div>
                                </div>
                                <div className={ style.codeLine }>
                                    <div className={ style.codeType }>Commision Junction</div>
                                    <div className={ style.codeValue }>{ affiliateCodes.cj }</div>
                                </div>
                                <div className={ style.codeLine }>
                                    <div className={ style.codeType }>Target</div>
                                    <div className={ style.codeValue }>{ affiliateCodes.target }</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={ style.tabs }>
                        <InternalLink to={ `${ this.props.location.pathname }?tab=articles` }
                        className={ style.tabOption }
                        data-active={ activeTab == 'articles' }>
                            Articles { !fetchingArticles && `(${ articles.length })` }
                        </InternalLink>
                        <InternalLink to={ `${ this.props.location.pathname }?tab=products` }
                        className={ style.tabOption }
                        data-active={ activeTab == 'products' }>
                            Products { products.length !== undefined && `(${ products.length })` }
                        </InternalLink>
                        <InternalLink to={ `${ this.props.location.pathname }?tab=reviews` }
                        className={ style.tabOption }
                        data-active={ activeTab == 'reviews' }>
                            Reviews { reviews.length !== undefined && `(${ reviews.length })` }
                        </InternalLink>
                    </div>
                </div>
                <div className={ style.body }>
                    { activeTab == 'articles' &&
                        ( fetchingArticles ?
                            <LoadingReplace />
                            :
                            <ArticlesTable articles={ articles }
                            onArticleUpdated={ this.articleUpdated }
                            elementHeight={ 70 } />
                        )
                    }
                    { activeTab == 'products' &&
                        ( fetchingProducts ?
                            <LoadingReplace />
                            :
                            <InfiniteProductsTable products={ products }
                            loadMore={ () => { return this.loadProducts( this.props.match.params.uid ); } }
                            onColumnSort={ this.onProductListSort }
                            currentSort={ this.productQueryObject.sort }
                            onProductUpdated={ this.productUpdated }/>
                        )
                    }
                    { activeTab == 'reviews' &&
                        ( fetchingReviews ?
                            <LoadingReplace />
                            :
                            <SortableReviewsTable reviews={ reviews } onReviewUpdated={ this.reviewUpdated } />
                        )
                    }
                </div>
                <EditUserModal closeModal={ this.onEditClose }
                onSubmit={ this.onEditSubmit }
                user={ user } />

                <UpdatePasswordModal id={ user.userid } visible={ this.state.showUpdatePass }
                closeHandler={ () => ( this.setState( { showUpdatePass: false } ) ) } />
            </section>
        );
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        showModal: ( modalName ) => {
            dispatch( showModal( modalName ) );
        },
        hideModal: ( modalName ) => {
            dispatch( hideModal( modalName ) );
        },
        getUser: ( userid ) => {
            return dAPI.get( `/admin/users/${ userid }` );
        },
        updateUser: ( userid, data ) => {
            return dAPI.patch( `/users/${ userid }`, dAPI.clean.admin.user( data ) );
        },
        updateUserAffiliateCode: ( userid, data ) => {
            return dAPI.post( `/users/${ userid }/affiliatecode`, data );
        },
        getProducts: ( userid, queryObject ) => {
            return dAPI.get( `/users/${ userid }/desires`, queryObject );
        },
        getUsersToken: ( userid ) => {
            return dAPI.get( `/admin/userToken/${ userid }` );
        },
        setTokens: ( tokens ) => {
            dispatch( setTokens( tokens ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( IndividualUserPage );
